import { BankRow } from '@mobile/screens/withdraw-banks/bank-list'
import { ALL_WITHDRAW_BANKS } from '@mobile/screens/withdraw-banks/data'
import { selectedCurrentUser } from '@shared-core/features/backend'
import { useBanks } from '@shared-core/hooks/use-banks'
import { useI18N } from '@shared-core/hooks/use-i18n'
import { type RootRouteProps, ScreensList, useNavigation, useRoute } from '@shared-core/navigation'
import { useAppSelector } from '@shared-core/store'
import { formatPhoneDisplay } from '@shared-core/utils/phone'
import { Header } from '@shared-ui/components/ui/header'
import { ScreenWrapperWithoutScroll } from '@shared-ui/components/ui/screen-wrappers/screen-wrapper'
import { GText } from '@shared-ui/components/ui/text'
import { useMemo } from 'react'
import { FlatList, View } from 'react-native'
import locales from './index.i18n.json'
import { useCreateStyles } from './styles'

export function ScreenWithdrawBanks() {
  const styles = useCreateStyles()
  const currentUser = useAppSelector(selectedCurrentUser)
  const route = useRoute<RootRouteProps<ScreensList.WITHDRAW_BANKS>>()
  const navigation = useNavigation()
  const { t } = useI18N(locales)

  const banks = useBanks()
  const availableBanks = useMemo(
    () => ALL_WITHDRAW_BANKS.filter((bank) => banks?.some(({ id }) => id === bank.id)),
    [banks],
  )

  return (
    <ScreenWrapperWithoutScroll style={styles.screen}>
      <Header isBackButton exitCross={false} />
      <View style={styles.content}>
        <View style={styles.titleBlock}>
          <GText fw={600} style={styles.title}>
            {t('select-title')}
          </GText>
          <GText style={styles.subtitle}>
            {t('by-phone')}{' '}
            <GText fw={500} style={styles.phone}>
              {formatPhoneDisplay(currentUser?.phone?.number ?? '')}
            </GText>
          </GText>
        </View>
        <FlatList
          data={availableBanks}
          keyExtractor={(bank) => bank.id}
          renderItem={({ item }) => (
            <BankRow
              bank={item}
              onPress={() =>
                navigation.navigate(ScreensList.WITHDRAW_AMOUNT, { bank: item.id, cardId: route.params?.cardId })
              }
            />
          )}
          style={styles.screenList}
          contentContainerStyle={styles.listContent}
          keyboardShouldPersistTaps="handled"
          showsVerticalScrollIndicator={false}
        />
      </View>
    </ScreenWrapperWithoutScroll>
  )
}
